import * as React from 'react';
import { Link } from 'react-router-dom';
import ICompaniesListData from '@appComponents/CompaniesListData/ICompaniesListData';
import { ICompanyItem } from '@company/components/CompaniesList/ICompaniesList';
import { shortenText } from '@features/utils/functions';
import CurrencyElement from '@appComponents/CurrencyElement/CurrencyElement';
import noPhotoCompany from '@images/no_photo_company.png';

import AsyncImage from '@appComponents/AsyncImage/AsyncImage';

import * as elements from '@appStyles/_elements.module.scss';
import * as style from './CompaniesListDataStyle.module.scss'

const CompaniesListData: React.SFC<ICompaniesListData> = (props) => {
  const { companiesList } = props;

  const companyPageUrl = (creatorId: number | null, ownerId: number | null, companySlug: string): string => {
    const profileId = props.profileId;
    const canModifyCompanyData = (creatorId === profileId || ownerId === profileId) ? true : false;
    return canModifyCompanyData ? `/companies/${companySlug}/overview` : `/companies/${companySlug}`;
  };

  return (
    companiesList.length > 0 ?
      (
        <div className={elements.tableContainer}>
          <div className={elements.tableHead}>
            <div className={elements.tableHeadRow}>
              <div className={elements.tableHeader}>Company</div>
              <div className={elements.tableHeader}>Location</div>
              <div className={elements.tableHeader}>Website</div>
              <div className={elements.tableHeader}>Market</div>
              <div
                className={[elements.tableHeader, style.textRight, style.keepWhitespace].join(' ')}
              >
                Disclosed Funding
              </div>
            </div>
          </div>
          <div className={elements.tableBody}>
            {
              companiesList.map((company:ICompanyItem) => {
                const website = company.social_media.website;

                return (
                  <div key={company.id} className={elements.tableRow} data-cy={`company-${company.slug}`}>
                    <div className={[elements.tableItem, style.itemDetails].join(' ')}>
                      <div className={style.companyLogo} data-cy="company-avatar">
                        <AsyncImage image={company.avatar.url} fallback={noPhotoCompany}>
                          <img
                            alt=""
                            className={style.logo}
                          />
                        </AsyncImage>
                      </div>
                      <div className={style.companyDetails} data-cy="company-name">
                        {
                          props.connectedToRouter ?
                            (
                              <Link to={`/companies/${company.slug}`} className={style.companyName}>
                                {company.name}
                              </Link>
                            ) :
                            (
                              <a
                                href={companyPageUrl(company.creator_id, company.profile_id, company.slug)}
                                className={style.companyName}
                              >
                                {company.name}
                              </a>
                            )
                        }
                        <span className={style.companyDescription} data-cy="company-description">
                          {shortenText(company.description)}
                        </span>
                      </div>
                    </div>
                    <div className={[elements.tableItem, style.keepWhitespace].join(' ')} data-cy="company-country">
                      <span className={style.label}>Location</span>
                      {company.location.country_name}
                    </div>
                    <div
                      className={[elements.tableItem,
                        website && website.length > 47 ? style.itemWebsiteBreak : ''].join(' ')}
                      data-cy="company-website"
                    >
                      <span className={style.label}>Website</span>
                      <a href={website} target="_blank" rel="noopener noreferrer">{website}</a>
                    </div>
                    <div
                      className={[elements.tableItem].join(' ')}
                      data-cy="company-market"
                    >
                      <span className={[style.label, style.marginRight].join(' ')}>Market</span>
                      {company.markets.join(', ')}
                    </div>
                    <div className={[elements.tableItem, style.itemRaised].join(' ')} data-cy="company-funding">
                      <span className={style.label}>Disclosed Funding</span>
                      {company.total_raised !== 0 && <CurrencyElement value={company.total_raised} currency={'usd'}/>}
                    </div>
                  </div>
                );
              })
            }
          </div>
        </div>
      ) : null
  );
};

export default CompaniesListData;
